let getToken: () => string | null = () => null;

export function bindDicomAccessToken(getter: () => string | null): void {
  getToken = getter;
}

export function dicomRequestHeaders(imageId: string): Record<string, string> {
  const url = new URL(imageId.replace(/^wadors:/, ''), window.location.origin);
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/dicom-web/')) return {};
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
